// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pick-contract__left[data-v-01992803]{height:calc(100% - 8px);overflow:auto;padding:0;background:#fff}.pick-contract__right[data-v-01992803]{height:calc(100% - 8px);overflow:auto;background-color:#e9f0f5;padding:5px}.pick-contract__empty[data-v-01992803]{background:#fff;height:100%;display:flex;align-items:center;justify-content:center;padding:50px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
